export const CUSTOMER_PAST_PURCHASES_LIST_REQUEST =
  'CUSTOMER_PAST_PURCHASES_LIST_REQUEST';
export const CUSTOMER_PAST_PURCHASES_LIST_SUCCESS =
  'CUSTOMER_PAST_PURCHASES_LIST_SUCCESS';
export const CUSTOMER_PAST_PURCHASES_LIST_FAILURE =
  'CUSTOMER_PAST_PURCHASES_LIST_FAILURE';
